/* eslint-disable max-len */

import React from 'react';
import Link from 'next/link';

import { getBirthday } from '@/components/new-brief/helpers';

import {
    mockedStatistics,
    modalBodyleftInformation,
} from './mockedData';
import style from './MyNetwork.module.css';
import {
    birthdaySoon, formatLastInteractionDate, getContactInteractions, getCreationDate,
    selectInteractionIcon,
} from './helpers';

function ModalBody({ data, lastInteraction }) {
    if (!data) {
        return null;
    }

    const formatedData = {
        ...data,
        createdAt: getCreationDate(data.createdAt),
        birthday: getBirthday(data.birthday),
        lastInteraction: {
            subject: lastInteraction?.subject,
            date: formatLastInteractionDate(lastInteraction?.whenHappened, true),
        },
    };

    const isBirthdaySoon = birthdaySoon(data.birthday, data.displayName);

    return (
        <div className="w-full h-full bg-lightGray flex flex-col md:flex-row items-start pt-6">
            <div className="flex flex-col items-start justify-start">
                <p className="font-bold ml-5 md:ml-7 mb-2">Contact details</p>
                <div className="flex flex-col w-full items-center justify-start mb-10">
                    {modalBodyleftInformation.map((e) => (
                        <div key={e.key} className="flex min-w-[80vw] md:min-w-[350px] max-w-[80vw] md:max-w-[350px] mx-0 ml-4 mr-4 py-1 my-1 md:mx-6 bg-cirrusWhite justify-start items-start rounded-lg border border-solid border-shadeStoneGray">
                            <p className="min-w-[60px] max-w-[60px] md:min-w-[70px] md:max-w-[70px] text-[12px] font-bold opacity-[60%] pt-[1px] ml-4 mt-2">{e?.title?.toUpperCase()}</p>
                            <div className="flex items-start justify-between mr-2 w-full">
                                <div className="flex flex-col ml-4 my-2">
                                    <a href={e.link || null} className={`text-[14px] ${e.link ? 'text-progressBarBlue break-all md:break-normal' : ''} `}>
                                        {formatedData[e.info]
                                            ? `${e.pre} ${formatedData[e.info]}`
                                            : '-'}
                                    </a>
                                    {formatedData[e.info] && <p className="italic text-[12px] text-gray">{e.from}</p>}
                                </div>
                                {/* {e.from && (
                                    <div className="ml-4 w-[30px]">
                                        <div>
                                            <button type="button" aria-label="thumbs-up" className="bg-shadeStoneGray p-2 rounded-lg mb-1">
                                                <ThumbsUpSolid className="w-3 text-cleanSlate" />
                                            </button>
                                            <button type="button" aria-label="thumbs-down" className="bg-shadeStoneGray p-2 rounded-lg flex items-center">
                                                <ThumbsDownSolid className="w-3 text-cleanSlate" />
                                            </button>
                                        </div>
                                    </div>
                                )} */}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="w-full grow md:w-auto mr-0 md:mr-4">
                <div className="flex flex-col md:flex-row items-center justify-center md:justify-between mt-4 md:mt-0 mb-4">
                    {mockedStatistics.map((ele, i) => (
                        <div key={ele.key} className={`${i !== mockedStatistics.length - 1 ? 'mb-2 md:mb-0 md:mr-5' : ''} w-[210px] flex flex-col items-center justify-center bg-cirrusWhite rounded-lg border border-solid border-shadeStoneGray py-4 px-14`}>
                            <p className="tracking-wider text-[36px] font-bold">{getContactInteractions(formatedData.mappings[0].contact, ele.title)}</p>
                            <p>{ele.title}</p>
                        </div>
                    ))}
                </div>
                <div className="bg-cirrusWhite rounded-lg ml-4 md:ml-0 mb-4 px-4 pt-4 mr-4 pb-4 md:mr-0 border border-solid border-shadeStoneGray">
                    {isBirthdaySoon ? (
                        <div className="flex flex-col md:flex-row items-center justify-between bg-progressBarBlue bg-opacity-20 rounded-lg border border-solid border-noonBlue ">
                            <div className="flex flex-col justify-center ml-0 md:ml-5 py-2">
                                <p className="text-center md:text-left font-semibold mb-1">{isBirthdaySoon}</p>
                                <div className="flex items-center">
                                    <p className="text-center md:text-left text-[14px]">
                                        {`Last year you sent ${data.givenName || data.displayName.split(' ')[0]} a birthday card.`}
                                        <Link href="/my-network" className="pl-[2px] text-[14px] text-progressBarBlue">View</Link>
                                    </p>
                                </div>
                            </div>
                            <div className="px-3 py-2 bg-cirrusWhite rounded-lg border border-solid border-cleanSlate mr-0 mb-2 md:mb-0 md:mr-5">
                                <button type="button" className="font-medium text-[14px]">
                                    Send a card
                                </button>
                            </div>
                        </div>
                    ) : null}
                    <p className="font-bold mb-4 pl-1">Recent interactions</p>
                    <div className={`overflow-y-auto  ${style.scrollBar}`}>
                        {lastInteraction?.subject && (
                            <div className="flex flex-col md:flex-row items-center justify-between rounded-lg border border-solid border-shadeStoneGray my-2 md:my-3 mr-1 md:mr-4 py-1">
                                <div className="flex items-center justify-start w-full">
                                    <div className="ml-2 md:ml-5 mr-0 md:mr-4">
                                        {selectInteractionIcon(formatedData.lastInteraction.subject, true)}
                                    </div>
                                    <div className="flex flex-col md:flex-row justify-between ml-2 md:ml-0 md:w-full">
                                        <p
                                            className="font-bold text-[14px] md:text-[16px] text-progressBarBlue"
                                        >
                                            {formatedData.lastInteraction.subject}
                                        </p>
                                        <div className="flex justify-end items-center md:min-w-[250px]">
                                            <p className="text-[12px] md:text-[14px] pr-5 ">{formatedData.lastInteraction.date}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalBody;
